<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card">
      @if (srDetailLoading) {
        <app-skeleton-loader
          [formLoader]="true"
          [noOfFields]="7"
        ></app-skeleton-loader>
      } @else {
        <!-- Action for show notes -->
        @if (srNumber && srInprgoressAwating && !srDetailLoading) {
          <app-validation-message
            type="info"
            [content]="{
              title: 'SECTION_NOTES' | translate,
              message: 'SECTION_NOTES_DESCRIPTION' | translate,
            }"
            [showbutton]="false"
            [buttonText]="'VIEW_NOTES' | translate"
            (onBtnClick)="showNotes = true"
          />
        }

        <!-- Entrepreneurship form 1 -->
        @if (showEntrepreneurshipForm) {
          @if (form) {
            <form [formGroup]="form">
              @if (step >= 1) {
                <section>
                  <h1 class="section-heading">
                    {{ "ENTREPRENEURSHIP.TITLE" | translate }}
                  </h1>
                  <div class="fields-container">
                    <div class="field-control">
                      <app-checkbox
                        [control]="form.get('uaeNational')!"
                        [disabled]="true"
                        [options]="[
                          {
                            label: 'ENTREPRENEURSHIP.UAE_NATIONAL' | translate,
                            value: 'Yes',
                          },
                        ]"
                      />
                    </div>
                    <div class="field-control">
                      <app-text-field
                        [label]="'ENTREPRENEURSHIP.FIRST_NAME' | translate"
                        [control]="form.get('firstName')!"
                        [maxlength]="100"
                      />
                    </div>
                    <div class="field-control">
                      <app-text-field
                        [label]="'ENTREPRENEURSHIP.LAST_NAME' | translate"
                        [control]="form.get('lastName')!"
                        [maxlength]="100"
                      />
                    </div>
                    <div class="field-control">
                      <app-text-field
                        [label]="
                          'ENTREPRENEURSHIP.EMIRATES_ID_NUMBER' | translate
                        "
                        [control]="form.get('emiratesIdNumber')!"
                        [maxlength]="20"
                        [validationMessages]="{
                          emiratesId:
                            'VALIDATION_MSG.VALID_EMIRATES_ID' | translate,
                        }"
                        (blur)="onEmiratesIdBlur()"
                      />

                      <div class="mb-2">
                        @if (emiratesIdChecking) {
                          <app-skeleton-loader
                            [pingLoder]="true"
                          ></app-skeleton-loader>
                        }
                        @if (emiratesIdChecked && !emiratesIdFound) {
                          <app-validation-message
                            [content]="{
                              title: 'ALERT.NO_RESULTS_TITLE' | translate,
                              message:
                                'VALIDATION_MSG.NO_EMIRATES_ID_FOUND'
                                | translate,
                            }"
                            type="error"
                          />
                        }
                      </div>
                    </div>
                    <div class="field-control">
                      @if (
                        form.get("mobileNumber") &&
                        form.get("mobileCountryCode")
                      ) {
                        <app-mobile-number
                          [label]="'ENTREPRENEURSHIP.MOBILE_NUMBER' | translate"
                          [countryCodeControl]="form.get('mobileCountryCode')!"
                          [control]="form.get('mobileNumber')!"
                          [validationMessages]="{
                            mobile:
                              'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
                            uaeMobile:
                              'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate,
                          }"
                        />
                      }
                    </div>
                    <div class="field-control">
                      <app-text-field
                        [label]="'ENTREPRENEURSHIP.EMAIL' | translate"
                        [control]="form.get('email')!"
                        [validationMessages]="{
                          email: 'VALIDATION_MSG.VALID_EMAIL' | translate,
                        }"
                        [maxlength]="100"
                      />
                    </div>
                  </div>
                </section>
              }
              @if (step >= 2) {
                <section>
                  <h1 class="section-heading">
                    {{ "ENTREPRENEURSHIP.TRADE_LICENSE_DETAILS" | translate }}
                  </h1>
                  <div class="fields-container">
                    <div class="field-control">
                      <app-option-field
                        [label]="
                          'ENTREPRENEURSHIP.TRADE_LICENSE_OR_MEMBERSHIP_NUMBER'
                            | translate
                        "
                        [options]="members"
                        [control]="form.get('tradeLicenseOrMembershipNumber')!"
                        (search)="handleSearch($event)"
                        [loading]="loadingMember"
                        [showMemberFilter]="true"
                        [memberSearchByOptions]="memberSearchByOptions"
                        [labelKey]="'Name'"
                        [valueKey]="'Value'"
                        (onSelectionChange)="updateMemberNumber($event)"
                      ></app-option-field>
                    </div>
                    <div class="field-control">
                      <app-text-field
                        [label]="
                          'ENTREPRENEURSHIP.TRADE_NAME_ENGLISH' | translate
                        "
                        [control]="form.get('tradeNameEnglish')!"
                        [maxlength]="150"
                      />
                    </div>
                    <div class="field-control">
                      <app-text-field
                        [label]="
                          'ENTREPRENEURSHIP.TRADE_NAME_ARABIC' | translate
                        "
                        [control]="form.get('tradeNameArabic')!"
                        [maxlength]="150"
                      />
                    </div>
                    <div class="field-control">
                      <app-option-field
                        [label]="
                          'ENTREPRENEURSHIP.COMPANY_NATIONALITY' | translate
                        "
                        [control]="form.get('companyNationality')!"
                        [lovType]="lookupKey.FIRM_TYPE"
                        [labelKey]="'Description'"
                        [valueKey]="'Description'"
                      ></app-option-field>
                    </div>
                    <div class="field-control">
                      <app-date
                        [control]="form.get('licenseIssueDate')"
                        [label]="
                          'ENTREPRENEURSHIP.LICENSE_ISSUE_DATE' | translate
                        "
                        [allowedDate]="'future'"
                      />
                    </div>
                    <div class="field-control">
                      <app-date
                        [control]="form.get('licenseExpiryDate')"
                        [label]="
                          'ENTREPRENEURSHIP.LICENSE_EXPIRY_DATE' | translate
                        "
                        [allowedDate]="'future'"
                      />
                    </div>
                    <!-- license issu date message -->
                    @if (licenseIssueDateInvalid) {
                      <app-validation-message
                        [content]="{
                          title: 'VALIDATION_MSG.ERROR' | translate,
                          message:
                            'VALIDATION_MSG.LICENSE_ISSUE_DATE_PAST'
                            | translate
                              : {
                                  cutOfDate: licIssueMinDate | date: 'longDate',
                                },
                        }"
                        type="error"
                        [showbutton]="false"
                      />
                    }
                    @if (detLicenseAuthorityInvalid) {
                      <app-validation-message
                        [content]="{
                          title: 'VALIDATION_MSG.ERROR' | translate,
                          message:
                            'VALIDATION_MSG.ENTREPRENEURSHIP_DET_LICENSE_ONLY'
                            | translate,
                        }"
                        type="error"
                        [showbutton]="false"
                      />
                    }
                    @if (ownerPartnerNationalityInvalid) {
                      <app-validation-message
                        [content]="{
                          title: 'VALIDATION_MSG.ERROR' | translate,
                          message:
                            'VALIDATION_MSG.ENTREPRENEURSHIP_OWNER_UAE_ONLY'
                            | translate,
                        }"
                        type="error"
                        [showbutton]="false"
                      />
                    }
                    <!-- Checking inprogress sr -->
                    <div class="mb-2">
                      @if (isCheckingPendingSr) {
                        <app-skeleton-loader
                          [pingLoder]="true"
                        ></app-skeleton-loader>
                      }
                    </div>
                  </div>
                </section>
              }
              @if (step >= 3 && visibleCompanyDetail) {
                <section>
                  <h1 class="section-heading">
                    {{ "ENTREPRENEURSHIP.COMPANY_DETAILS" | translate }}
                  </h1>
                  <div class="fields-container">
                    <div class="field-control">
                      <app-text-field
                        type="big-text"
                        [label]="
                          'ENTREPRENEURSHIP.BRIEF_BUSINESS_DESCRIPTION'
                            | translate
                        "
                        [control]="form.get('briefBusinessDescription')!"
                        [maxlength]="1000"
                      />
                    </div>

                    <div class="field-control">
                      <app-text-field
                        type="number"
                        [label]="
                          'ENTREPRENEURSHIP.NUMBER_OF_EMPLOYEES' | translate
                        "
                        [control]="form.get('numberOfEmployees')!"
                        [maxlength]="10"
                      />
                    </div>
                    <div class="field-control">
                      <app-boolean
                        [label]="
                          'ENTREPRENEURSHIP.OTHER_TRADE_LICENSES_UAE'
                            | translate
                        "
                        [control]="form.get('otherTradeLicensesUae')!"
                        [options]="standardOption"
                      ></app-boolean>
                    </div>
                    <div class="field-control">
                      <app-text-field
                        [label]="'ENTREPRENEURSHIP.COMPANY_WEBSITE' | translate"
                        [control]="form.get('companyWebsite')!"
                        [maxlength]="150"
                      />
                    </div>
                  </div>
                </section>
              }
              @if (step >= 4 && visibleBankAccountDetail) {
                <section>
                  <h1 class="section-heading">
                    {{
                      "ENTREPRENEURSHIP.COMPANY_BANK_ACCOUNT_DETAILS"
                        | translate
                    }}
                  </h1>
                  <div class="fields-container">
                    <div class="field-control">
                      <app-validation-message
                        [type]="'info'"
                        [content]="{
                          title:
                            'ENTREPRENEURSHIP.ACCOUNT_DETAILS_INFO' | translate,
                        }"
                      >
                      </app-validation-message>
                    </div>
                  </div>
                  <div class="fields-container">
                    <div class="field-control">
                      <app-text-field
                        [label]="
                          'ENTREPRENEURSHIP.ACCOUNT_HOLDER_NAME' | translate
                        "
                        [control]="form.get('accountHolderName')!"
                        [maxlength]="150"
                      />
                    </div>
                    <div class="field-control">
                      <app-option-field
                        [label]="'ENTREPRENEURSHIP.BANK_NAME' | translate"
                        [control]="form.get('bankName')!"
                        [lovType]="lookupKey.XX_BANK_CODES"
                        (onSelectionChange)="onBankChange($event)"
                      />
                    </div>
                    <div class="field-control">
                      <app-text-field
                        [label]="'ENTREPRENEURSHIP.ACCOUNT_NUMBER' | translate"
                        [control]="form.get('accountNumber')!"
                        [maxlength]="50"
                      />
                    </div>
                    <div class="field-control">
      <app-text-field
        [label]="'ENTREPRENEURSHIP.COMPANY_IBAN' | translate"
        [control]="form.get('companyIban')!"
        [maxlength]="34"
      />
                    </div>

                    <div class="field-control">
                      <app-text-field
                        [label]="'ENTREPRENEURSHIP.SWIFT_CODE' | translate"
                        [control]="form.get('swiftCode')!"
                        [maxlength]="50"
                      />
                    </div>
                  </div>
                </section>
              }
              @if (step >= 5 && visibleBankAccountDetail) {
                <section>
                  <h1 class="section-heading">
                    {{ "ENTREPRENEURSHIP.UPLOAD_DOCUMENTS" | translate }}
                  </h1>
                  <div class="fields-container">
                    <div class="field-control">
                      <app-validation-message
                        [type]="'info'"
                        [content]="{
                          title: 'ENTREPRENEURSHIP.DOCUMENTS_NOTE' | translate,
                        }"
                      >
                      </app-validation-message>
                    </div>
                  </div>
                  <div class="fields-container">
                    @if (loadingDoc) {
                      <app-skeleton-loader
                        [formLoader]="true"
                        [noOfFields]="3"
                      ></app-skeleton-loader>
                    } @else {
                      @for (dt of mainFromSectionDocs; track $index) {
                        <div class="field-control">
                          <app-file
                            #fileCmp
                            [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                            [documentType]="dt.nameEn"
                            (folderMissing)="openFolder()"
                            [showAction]="showActions"
                            [folder]="srFolder"
                            [documentServiceType]="documentServiceType.ENTPR"
                          ></app-file>
                        </div>
                      }
                    }
                  </div>
                </section>

                <div class="fields-container">
                  <div class="field-control">
                    <app-checkbox
                      [control]="form.get('confirmInformation')!"
                      [disabled]="!showActions"
                      [options]="[
                        {
                          label:
                            'ENTREPRENEURSHIP.CONFIRM_INFORMATION' | translate,
                          value: 'Yes',
                        },
                      ]"
                    />
                  </div>
                </div>
              }

              <!-- Submit action first from -->
              @if (showActions && !showSupportServiceForm) {
                <div class="fields-container">
                  <!-- Technical error msg -->
                  @if (technicalErrorMsg) {
                    <app-validation-message
                      [type]="'error'"
                      [content]="{
                        title: 'VALIDATION_MSG.ERROR' | translate,
                        message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate,
                      }"
                      [showbutton]="false"
                    ></app-validation-message>
                  }
                </div>
                <div class="btn-section buttons-group">
                  @if (formSubmitLoader) {
                    <app-button
                      type="button"
                      classesName="btn-edge-cut btn-width-auto"
                      [label]="'PLEASE_WAIT' | translate"
                      [disabled]="true"
                    ></app-button>
                  } @else {
                    @if (step < 5) {
                      <app-button
                        type="button"
                        classesName="btn-edge-cut btn-width-auto"
                        [label]="'BUTTONS.NEXT' | translate"
                        (onBtnClick)="nextStep()"
                      ></app-button>
                    } @else {
                      <app-button
                        type="button"
                        classesName="btn-edge-cut btn-width-auto"
                        [label]="'BUTTONS.SUBMIT' | translate"
                        (onBtnClick)="submit()"
                      ></app-button>
                    }
                    @if (step > 2 && !isCheckingPendingSr) {
                      <app-button
                        type="button"
                        classesName="card-edge-cut-white btn-width-auto"
                        [label]="'BUTTONS.SAVE_CLOSE' | translate"
                        (onBtnClick)="saveAndClose()"
                      ></app-button>
                    }
                  }
                </div>
              }
            </form>
          }
        }
        <!-- Support services form 2 & 3-->
        @if (showSupportServiceForm && this.dcParamsOptions) {
          @if (supportForm) {
            <form [formGroup]="supportForm">
              <section>
                <h1 class="section-heading">
                  {{ "BUSINESSSUPPORT.TITLE" | translate }}
                </h1>
                <div class="fields-container">
                  <div class="field-control">
                    <app-validation-message
                      type="info"
                      [showbutton]="false"
                      [content]="{
                        title: 'BUSINESSSUPPORT.INTRO_TEXT',
                        message: 'BUSINESSSUPPORT.REVIEW_NOTE',
                        sections: [
                          {
                            title: 'BUSINESSSUPPORT.FINANCIAL_SUPPORT_INFO',
                            items: [
                              'BUSINESSSUPPORT.FINANCIAL_SUPPORT_ITEM_1'
                                | translate
                                  : {
                                      amount: getMasterLimitFormatted(
                                        'LIC_REIMBURSE_LIMIT'
                                      ),
                                    },
                              'BUSINESSSUPPORT.FINANCIAL_SUPPORT_ITEM_2'
                                | translate
                                  : {
                                      amount: getMasterLimitFormatted(
                                        'VISA_REIMBURSE_LIMIT'
                                      ),
                                    },
                              'BUSINESSSUPPORT.FINANCIAL_SUPPORT_ITEM_3'
                                | translate
                                  : {
                                      amount: getMasterLimitFormatted(
                                        'UTILITY_REIMBURSE_LIMIT'
                                      ),
                                    },
                            ],
                          },
                          {
                            title: 'BUSINESSSUPPORT.IN_KIND_SUPPORT_INFO',
                            items: ['BUSINESSSUPPORT.IN_KIND_SUPPORT_DESC'],
                          },
                          {
                            title: 'BUSINESSSUPPORT.STRATEGIC_SUPPORT_INFO',
                            items: ['BUSINESSSUPPORT.STRATEGIC_SUPPORT_DESC'],
                          },
                        ],
                      }"
                    />
                  </div>
                </div>
              </section>
              @if (!showBusinessSupportSections) {
                <div class="fields-container">
                  <div class="field-control">
                    <app-validation-message
                      [type]="'info'"
                      [content]="{
                        title: 'ENTREPRENEURSHIP.LIMIT_RICHED' | translate,
                      }"
                    >
                    </app-validation-message>
                  </div>
                </div>
              }
              @if (showBusinessSupportSections) {
                <section>
                  <h1 class="section-heading">
                    {{ "BUSINESSSUPPORT.FINANCIAL_SUPPORT_TITLE" | translate }}
                  </h1>
                  <div class="fields-container">
                    @if (showTradeLicenseCostField) {
                      <div class="field-control">
                        <app-text-field
                          type="number"
                          [label]="
                            'BUSINESSSUPPORT.TRADE_LICENSE_COST_QUESTION'
                              | translate
                          "
                          [placeholder]="
                            'BUSINESSSUPPORT.TRADE_LICENSE_COST_HINT'
                              | translate
                                : {
                                    amount: getReimburseLimitFormatted(
                                      'LIC_REIMBURSE_LIMIT'
                                    ),
                                  }
                          "
                          [control]="supportForm.get('tradeLicenseCost')!"
                          [maxlength]="10"
                        />
                      </div>
                    }
                    @if (showVisaProcessingCostField) {
                      <div class="field-control">
                        <app-text-field
                          type="number"
                          [label]="
                            'BUSINESSSUPPORT.VISA_PROCESSING_COST_QUESTION'
                              | translate
                          "
                          [placeholder]="
                            'BUSINESSSUPPORT.VISA_PROCESSING_COST_HINT'
                              | translate
                                : {
                                    amount: getReimburseLimitFormatted(
                                      'VISA_REIMBURSE_LIMIT'
                                    ),
                                  }
                          "
                          [control]="supportForm.get('visaProcessingCost')!"
                          [maxlength]="10"
                        />
                      </div>
                    }
                    @if (showDewaCostField) {
                      <div class="field-control">
                        <app-text-field
                          type="number"
                          [label]="
                            'BUSINESSSUPPORT.DEWA_COST_QUESTION' | translate
                          "
                          [placeholder]="
                            'BUSINESSSUPPORT.DEWA_COST_HINT'
                              | translate
                                : {
                                    amount: getReimburseLimitFormatted(
                                      'UTILITY_REIMBURSE_LIMIT'
                                    ),
                                  }
                          "
                          [control]="supportForm.get('dewaCost')!"
                          [maxlength]="10"
                        />
                      </div>
                    }
                    <div class="field-control">
                      <app-boolean
                        [label]="
                          'BUSINESSSUPPORT.VAT_SUPPORT_QUESTION' | translate
                        "
                        [control]="supportForm.get('vatSupport')!"
                        [options]="standardOption"
                      ></app-boolean>
                    </div>
                  </div>
                </section>

                <section>
                  <h1 class="section-heading">
                    {{ "BUSINESSSUPPORT.UPLOAD_DOCUMENTS" | translate }}
                  </h1>
                  <div class="fields-container">
                    @if (loadingDoc) {
                      <app-skeleton-loader
                        [formLoader]="true"
                        [noOfFields]="3"
                      ></app-skeleton-loader>
                    } @else {
                      @for (dt of supportFormDocs; track $index) {
                        @if (shouldShowSupportDoc(dt)) {
                          <div class="field-control">
                            <app-file
                              #fileCmp
                              [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                              [documentType]="dt.nameEn"
                              (folderMissing)="openFolder()"
                              [showAction]="showActions"
                              [folder]="srFolder"
                              [documentServiceType]="documentServiceType.ENTPR"
                            ></app-file>
                          </div>
                        }
                      }
                    }
                  </div>
                </section>
              }
              <!-- Inkind support setction -->
              <section>
                <h1 class="section-heading">
                  {{ "BUSINESSSUPPORT.IN_KIND_SUPPORT_TITLE" | translate }}
                </h1>
                <div class="fields-container">
                  <div class="field-control">
                    <app-text-field
                      type="big-text"
                      [label]="
                        'BUSINESSSUPPORT.MARKET_INSIGHTS_QUESTION' | translate
                      "
                      [placeholder]="
                        'BUSINESSSUPPORT.MARKET_INSIGHTS_PLACEHOLDER'
                          | translate
                      "
                      [control]="supportForm.get('marketInsights')!"
                      [maxlength]="1000"
                    />
                  </div>
                  <div class="field-control">
                    <app-checkbox
                      [label]="
                        'BUSINESSSUPPORT.TRAINING_WORKSHOPS_QUESTION'
                          | translate
                      "
                      [control]="supportForm.get('trainingWorkshops')!"
                      [options]="trainingWorkshopsOptions"
                      [disabled]="!showActions"
                    />
                  </div>
                  <div class="field-control">
                    <app-boolean
                      [label]="
                        'BUSINESSSUPPORT.AI_CYBERSECURITY_QUESTION' | translate
                      "
                      [control]="supportForm.get('aiCyberTraining')!"
                      [options]="standardOption"
                    ></app-boolean>
                  </div>
                </div>
              </section>

              <section>
                <h1 class="section-heading">
                  {{ "BUSINESSSUPPORT.STRATEGIC_SUPPORT_TITLE" | translate }}
                </h1>
                <div class="fields-container">
                  <div class="field-control">
                    <app-checkbox
                      [label]="
                        'BUSINESSSUPPORT.STRATEGIC_PROGRAMS_QUESTION'
                          | translate
                      "
                      [control]="supportForm.get('strategicPrograms')!"
                      [options]="strategicProgramsOptions"
                      [disabled]="!showActions"
                    />
                  </div>
                  <div class="field-control">
                    <app-checkbox
                      [label]="
                        'BUSINESSSUPPORT.SERVICE_SUPPORT_QUESTION' | translate
                      "
                      [otherInfo]="
                        'BUSINESSSUPPORT.SERVICE_SUPPORT_NOTE' | translate
                      "
                      [control]="supportForm.get('serviceSupport')!"
                      [options]="serviceSupportOptions"
                      [disabled]="!showActions"
                    />
                  </div>
                </div>
              </section>

              @if (showActions) {
                @if (showSupportAtLeastOneError) {
                  <app-validation-message
                    [type]="'error'"
                    [content]="{
                      title: 'BUSINESSSUPPORT.AT_LEAST_ONE_REQUIRED',
                      message: '',
                      sections: [
                        {
                          title: '',
                          items: [
                            showTradeLicenseCostField
                              ? 'BUSINESSSUPPORT.TRADE_LICENSE_COST_QUESTION'
                              : '',
                            showVisaProcessingCostField
                              ? 'BUSINESSSUPPORT.VISA_PROCESSING_COST_QUESTION'
                              : '',
                            'BUSINESSSUPPORT.DEWA_COST_QUESTION',
                          ],
                        },
                      ],
                    }"
                    [showbutton]="false"
                  ></app-validation-message>
                }
                @if (showInKindLeastOneError) {
                  <app-validation-message
                    [type]="'error'"
                    [content]="{
                      title: 'BUSINESSSUPPORT.AT_LEAST_ONE_REQUIRED',
                      message: '',
                      sections: [
                        {
                          title: '',
                          items: [
                            'BUSINESSSUPPORT.MARKET_INSIGHTS_QUESTION',
                            'BUSINESSSUPPORT.TRAINING_WORKSHOPS_QUESTION',
                            'BUSINESSSUPPORT.AI_CYBERSECURITY_QUESTION',
                            'BUSINESSSUPPORT.STRATEGIC_PROGRAMS_QUESTION',
                            'BUSINESSSUPPORT.SERVICE_SUPPORT_QUESTION',
                          ],
                        },
                      ],
                    }"
                    [showbutton]="false"
                  ></app-validation-message>
                }

                <div class="fields-container">
                  <!-- Technical error msg -->
                  @if (technicalErrorMsg) {
                    <app-validation-message
                      [type]="'error'"
                      [content]="{
                        title: 'VALIDATION_MSG.ERROR' | translate,
                        message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate,
                      }"
                      [showbutton]="false"
                    ></app-validation-message>
                  }
                </div>

                <div class="btn-section buttons-group">
                  @if (formSubmitLoader) {
                    <app-button
                      type="button"
                      classesName="btn-edge-cut btn-width-auto"
                      [label]="'PLEASE_WAIT' | translate"
                      [disabled]="true"
                    ></app-button>
                  } @else {
                    <app-button
                      type="button"
                      classesName="btn-edge-cut btn-width-auto"
                      [label]="'BUTTONS.SUBMIT' | translate"
                      (onBtnClick)="submitSupport()"
                    ></app-button>
                    <!-- <app-button
                      type="button"
                      classesName="card-edge-cut-white btn-width-auto"
                      [label]="'BUTTONS.SAVE_CLOSE' | translate"
                      (onBtnClick)="saveAndCloseSupport()"
                    ></app-button> -->
                  }
                </div>
              }
            </form>
          }
        }
      }
    </div>
  </div>
</div>

<div>
  <app-service-progress
    [serviceName]="'ENTREPRENEURSHIP.PROGRESS_LABEL' | translate"
    [completePercentage]="formProgress"
  />
</div>

@if (successModal) {
  <app-sr-submit-success-modal
    [srNumber]="srNumber"
    (onClose)="closeSuccessModal()"
  ></app-sr-submit-success-modal>
}
@if (showNotes) {
  <app-notes
    [srNumber]="srNumber"
    [allowSubmit]="true"
    (onClose)="showNotes = false"
  ></app-notes>
}

@if (pendingSrNumber) {
  <app-pending-sr-modal
    [srNumber]="pendingSrNumber"
    (onClose)="closependingSrModal()"
  />
}
